import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const FrontPluginDefault = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center bg-white rounded-[16px] shadow-sm p-6 mt-10 mx-auto max-w-lg">
      <h1 className="text-2xl font-bold mb-3 text-center">Welcome to Twilanswer for Front</h1>
      <p className="text-gray-600 text-center mb-6">
        To view call details, open a Twilanswer conversation in Front.<br />
        If you want to make a call, you can use the dialer below.
      </p>
      <Button
        variant="contained"
        sx={{
          backgroundColor: '#605bff',
          borderRadius: '8px',
          px: 4,
          py: 1.5,
          fontWeight: 600,
          fontSize: '1rem',
          textTransform: 'none',
          boxShadow: 1,
          ':hover': { backgroundColor: '#4b47cc', boxShadow: 2 },
        }}
        onClick={() => navigate('/dashboard/dialer')}
      >
        Go to Dialer
      </Button>
      <div className="mt-8 text-center text-sm text-gray-500">
        Need help?{' '}
        <a href="mailto:hello@twilanswer.com" className="text-[#605bff] hover:underline font-medium">
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default FrontPluginDefault; 